import store from "../store/index";
//------------------------
// get visibility options
//------------------------
export default function getVisibilityOptions(cur_visibility) {
  //----------------------
  // get all visibilities
  //----------------------
  const this_store = store;
  const visibilities = this_store.getters["combat/getVisibilities"];
  //-------------------------------------------
  // get available visibilities (excl current)
  //-------------------------------------------
  let avail_visibilities = visibilities.filter((a) => a.name != cur_visibility);
  return avail_visibilities;
}